module.exports = __webpack_public_path__ + "static/media/view-log-icon2.dc6eb6db.png";